import { collection, getDocs } from "firebase/firestore";

import { firebaseDb, isFirebaseConfigured, tryEnsureFirebaseAuth } from "data/firebase";

const COLLECTION = "listingInquiries";

function requireDb() {
  if (!isFirebaseConfigured || !firebaseDb) {
    throw new Error("Firebase yapılandırılmamış.");
  }
  return firebaseDb;
}

function str(value) {
  return value === undefined || value === null ? "" : String(value);
}

function asInquiry(id, raw = {}) {
  return {
    id,
    kind: str(raw.kind) || "business",
    channel: raw.channel === "email" ? "email" : "message",
    listingId: str(raw.listingId),
    listingTitle: str(raw.listingTitle),
    listingOwnerEmail: str(raw.listingOwnerEmail),
    listingOwnerPhone: str(raw.listingOwnerPhone),
    provinceId: str(raw.provinceId),
    fromName: str(raw.fromName),
    fromEmail: str(raw.fromEmail),
    fromPhone: str(raw.fromPhone),
    subject: str(raw.subject),
    message: str(raw.message),
    reportToAdmin: true,
    source: str(raw.source),
    userId: str(raw.userId),
    createdAt: str(raw.createdAt),
  };
}

export async function listListingInquiriesFromFirestore() {
  const db = requireDb();
  await tryEnsureFirebaseAuth();
  const snap = await getDocs(collection(db, COLLECTION));
  return snap.docs
    .map((item) => asInquiry(item.id, item.data()))
    .sort((left, right) => right.createdAt.localeCompare(left.createdAt));
}
